
import axios from "axios";
import { URL_BASE } from "../config/url-server";

const clientId = localStorage.getItem("client")
const accessToken = localStorage.getItem("token")


export const documentsByLot = async (lotId) => {
  const params = {lotId};
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}, params };
  try {
    const response = await axios.get(
      URL_BASE + "file/documents-by-lot",
      config
    );
    const listado = response.data || null;
    return listado;
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
};

export const deleteDocument = async (data) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.post(URL_BASE+"file/delete-document", data, config)
    return response;
  } catch (error) {
    console.error("Error captura :", error);
    return error.response;
  }
};






export const updateLocations = async (data) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.post(URL_BASE+"file/update-locations", data, config)
    return response;
  } catch (error) {
    console.error("Error captura :", error);
    return error.response;
  }
};




export const createLinesPalmsExcel = async (data) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.post(URL_BASE+"file/create-lines-palms-excel", data, config)
    return response;
  } catch (error) {
    console.error("Error captura :", error);
    return error.response;
  }
};





export const insertMovemensByLot = async (data) => {  
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.post(URL_BASE+"file/insert-movements-by-lot", data, config)
    return response;
  } catch (error) {
    console.error("Error captura :", error);    
    return error.response;
  }
};



export const crateAllByFarmExcel = async (data) => {
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.post(URL_BASE+"file/create-all-by-farm-excel", data, config)
    return response;
  } catch (error) {
    console.error("Error captura :", error);
    return error.response;
  }
};



export const insertRainFallExcel = async (data) => {
  
  const config = { headers: { client: clientId,Authorization: `Bearer ${accessToken}`}};
  try {
    const response = await axios.post(URL_BASE+"file/insert-rainfall-excel", data, config)
    return response;
  } catch (error) {
    console.error("Error captura :", error);    
    return error.response;
  }
};






  export default{
    updateLocations,
    createLinesPalmsExcel,
    crateAllByFarmExcel,
    insertMovemensByLot,
    documentsByLot,
    deleteDocument,
    insertRainFallExcel,
    insertMovemensByLot
  }

